import React from 'react'
import { connect } from 'react-redux'
import { Dropdown, Chart, ErrorBoundary } from 'components'
import { setActiveGoal } from 'store/actions'
import {
  getListOfGoals,
  getPlanPath,
  getPlanInvestmentPath,
  getGoalPath,
} from 'store/selectors'

function Planpath(props) {
  const {
    planPath,
    goalPath,
    goalList,
    investmentPath,
    setActiveGoal,
    location,
  } = props
  const editPanelOpen =
    location.pathname.includes('edit') || location.pathname.includes('profile')
  return (
    <div className="planpath">
      <ErrorBoundary>
        <div>
          <h5>Planned Wealth Path</h5>
          <Dropdown menuItems={goalList} handleUpdate={setActiveGoal} />
        </div>
        <Chart
          data={goalPath ? goalPath : planPath}
          xLabel="Age"
          yLabel="Portfolio Value"
          secondary={investmentPath}
          secondaryLabel="Monthly Investment"
          editPanelOpen={editPanelOpen}
        />
      </ErrorBoundary>
    </div>
  )
}

export default connect(
  state => ({
    goalList: getListOfGoals(state),
    planPath: getPlanPath(state),
    goalPath: state.activeGoal ? getGoalPath(state).goalPath : null,
    investmentPath: state.activeGoal
      ? getGoalPath(state).investments
      : getPlanInvestmentPath(state),
  }),
  { setActiveGoal }
)(Planpath)



// WEBPACK FOOTER //
// ./src/components/layout/Planpath.js